import React from "react";

export default function AboutProjectIt() { return <div dangerouslySetInnerHTML={{ __html: "" }} />; }
